import { render, staticRenderFns } from "./accordion-activity.vue?vue&type=template&id=35fa1e19"
import script from "./accordion-activity.vue?vue&type=script&lang=js"
export * from "./accordion-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports